module.exports = __webpack_public_path__ + "assets/img/guide_1.40582d59.png";